// @ts-strict-ignore
import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@node-space/hooks'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getReissueToken } from 'services/AuthService'
import { QueryMetaType } from 'types/reactQuery'
import { AuthToken } from 'types/types'
import { setAuthCookies, TEN_MINUTES } from 'utils/utils'

export const useRefreshSession = () => {
  const { isAuthed } = useAuth()

  const shouldRun = useMemo(() => !!isAuthed, [isAuthed])

  const meta: QueryMetaType = {
    onSuccess: (freshToken: AuthToken) => {
      setAuthCookies({ ...freshToken })
    },
    isErrorFatal: false,
  }

  useQuery({
    queryKey: reactQueryKeys.reissueToken(),
    queryFn: ({ signal }) => getReissueToken({ signal }),
    enabled: shouldRun,
    refetchIntervalInBackground: shouldRun,
    refetchInterval: shouldRun ? TEN_MINUTES : false, // Use RQ built-in timer, no useEffect needed
    meta,
  })
}
